import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * CcfPopoverIcon used to display add event icon in the schedule panel & app space
 * @param props - SvgIconProps
 * @example -- <CcfPopoverIcon />
 */
export function CcfPrimaryAddressIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M6.62529 12.5V8.75H9.27539V12.5H12.588V7.5H14.5756L7.95034 1.875L1.32507 7.5H3.31265V12.5H6.62529Z"
        fill="#24B3B3"
      />
    </SvgIcon>
  );
}

export default CcfPrimaryAddressIcon;
